
import axios from "axios";
import { url } from "../utils/confserveur";
import { enTetesPilotageScan } from "../utils/pilotageScan";
// Configuration globale d'axios
axios.defaults.withCredentials = true;

// Page de scan : `X-Pilotage-Scan: 1` sur chaque requête, le serveur lit alors
// le cookie de scan avant le JWT (cf. utils/pilotageScan.js).
axios.interceptors.request.use((config) => {
    const extra = enTetesPilotageScan();
    if (Object.keys(extra).length) config.headers = { ...(config.headers || {}), ...extra };
    return config;
});
// axios.js
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
    refreshSubscribers.push(cb);
};

const onRefreshed = () => {
    refreshSubscribers.forEach(cb => cb());
    refreshSubscribers = [];
};

const onRefreshFailed = () => {
    refreshSubscribers = [];
};

axios.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        
        if (error.response?.status === 401 && !originalRequest._retry) {

            // Pages de scan (téléphone relié par le QR projeté, chantier jeton) :
            // JAMAIS de renvoi vers la connexion, la page affiche elle-même le
            // refus (« appareil détaché », « connexion expirée »). Mais on TENTE
            // le rafraîchissement : en mode « Pas de téléphone ? Ouvrir ce lien
            // ici », la page tourne dans le navigateur du prof, avec ses cookies
            // de connexion ; quand son jeton d'accès expire, le serveur le voit
            // avant le cookie de scan et répond token_not_valid (bug de démo du
            // 2026-09-12, « Suivant ne fait rien »). Le refresh est là, il
            // suffit de s'en servir. Sur un vrai téléphone il n'y a pas de
            // refresh : la tentative échoue, la requête est rejetée, sans
            // redirection.
            const surPageScan = window.location.pathname.startsWith('/scan/');

            // Vérifier si c'est une déconnexion GAR
            const errorDetail = error.response?.data?.detail;
            if (errorDetail === 'GAR_LOGOUT') {
                window.location.href = '/login?reason=gar_logout';
                return Promise.reject(error);
            }
            
            // Si c'est l'endpoint de refresh qui échoue
            if (originalRequest.url?.includes('/api/token/refresh/')) {
                //console.log('❌ Refresh token invalide');
                if (!surPageScan) window.location.href = '/login?reason=session_expired';
                return Promise.reject(error);
            }
            
            originalRequest._retry = true;
            
            // ✅ Si un refresh est en cours, attendre et retry directement
            if (isRefreshing) {
              //  console.log('⏳ Refresh en cours, mise en attente...');
                return new Promise((resolve, reject) => {
                    subscribeTokenRefresh(() => {
                  //      console.log('🔄 Refresh terminé, retry de la requête');
                        // ✅ PAS DE NOUVEAU TRY - on retry directement !
                        resolve(axios(originalRequest));
                    });
                });
            }
            
            // ✅ Premier à déclencher le refresh
            isRefreshing = true;
       //     console.log('🔄 Lancement du refresh token...');
            
            try {
                await axios.post(
                    `${url}api/token/refresh/`,
                    {},
                    { 
                        withCredentials: true,
                        _skipInterceptor: true
                    }
                );
                
           //     console.log('✅ Token rafraîchi avec succès');
                isRefreshing = false;
                
                // Notifier toutes les requêtes en attente
                onRefreshed();
                
                // Retry la requête originale
                return axios(originalRequest);
                
            } catch (refreshError) {
         //       console.log('❌ Échec du refresh token');
                isRefreshing = false;
                onRefreshFailed();
                
                // Page de scan : la requête d'origine est rejetée avec SON
                // erreur (401), pas celle du refresh : c'est elle que la page
                // sait lire (jeton expiré → « Connexion expirée »).
                if (surPageScan) return Promise.reject(error);
                window.location.href = '/login?reason=session_expired';
                return Promise.reject(refreshError);
            }
        }
        
        return Promise.reject(error);
    }
);

export default axios;